module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_1.68085e6d.jpg";